import { styled, css } from 'styled-components';
import { colors } from '../../../abstracts';
export const DrawerHandle = styled.div.withConfig({
  componentId: "aui__sc-1mzpszz-0"
})(["width:52px;min-height:4px;z-index:1000;", " border-radius:10px;background:", ";"], ({
  $stickyAction
}) => css(["margin-bottom:", ";margin-top:", ";"], $stickyAction ? '-12px' : '6px', $stickyAction ? 'unset' : '15px'), colors.neutralBrighter);